<template>
	<el-dialog title="驳回" @closed="restDialog" append-to-body :visible.sync="dialogVisible" :close-on-click-modal="false" width="616px">
		<el-form style="width: 547px;" :model="dataForm" :rules="dataRule" ref="dataForm" label-width="99px">
			<el-form-item label="驳回原因" prop="failCause">
				<el-input type="textarea" v-model="dataForm.failCause" rows="3" maxlength="200"></el-input>
			</el-form-item>
			<el-form-item label="附件">
				<el-upload :headers="headerSet" class="uploadBox" :action="upAddr" :show-file-list="false" :on-success="
												  (res) => {
												    uploadSuccess(res);
												  }
												">
					<div class="uploadText">
						<a class="ellipsis" @click.prevent="downloadFile(fileObj.fileDownloadUrl,fileObj.fileName)">
							{{ dataForm.annex || ''}}
						</a>
						<i v-if="dataForm.annex" class="el-icon-close" @click="clearUp"></i>
					</div>
					<img slot="trigger" src="@/assets/img/upload.png" />
				</el-upload>
			</el-form-item>
		</el-form>
		<div slot="footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="dataSubmit">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import { downloadFile } from "@/utils";
	export default {
		data() {
			return {
				dialogVisible: false,
				orderId: '',
				dataForm: {},
				dataRule: {
					failCause: [{
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					}]
				},
				fileObj:{}
			};
		},
		computed: {
			upAddr() {
				return window.SITE_CONFIG.baseUrl + '/checkmall-file/api/file/upload';
			},
			headerSet() {
				return { 'X-Admin-Token': this.$cookie.get('X-Admin-Token') }
			}
		},
		methods: {
			downloadFile(url, fileName) {
				downloadFile(url, fileName);
			},
			restDialog(){
				this.dataForm = {};
				this.fileObj = {};
				this.$refs.dataForm.resetFields();
			},
			clearUp() {
				this.dataForm.annex = "";
				this.$forceUpdate();
			},
			uploadSuccess(response) {
				this.dataForm.annex = response.data.storage.fileName;
				this.fileObj = response.data.storage;
				this.$forceUpdate();
			},
			init(orderId) {
				this.orderId = orderId;
				this.dialogVisible = true;
			},
			dataSubmit() {
				this.$refs.dataForm.validate((valid) => {
					if (valid) {
						let params = {
							orderId: this.orderId,
							isReview: false,
              				...this.dataForm
						}
						params.annex = this.fileObj;
						this.$http.post(this.$api.orderApi.orderReview, params).then(({
							data
						}) => {
							this.$message({
								message: data.msg,
								type: "success"
							});
							this.dialogVisible = false;
							this.$router.push({
								name: "order"
							});
						});
					}
				})

			}
		}
	};
</script>

<style lang="scss" scoped>
	::v-deep .el-dialog__footer {
		margin-top: 0;

		.el-button {
			width: 80px;
			line-height: 38px;
			border-radius: 20px;
			font-size: 14px;
		}
	}
</style>
